const comments = [
  {
    user: '吃瓜一线群众',
    avatar: '瓜',
    time: '2分钟前',
    content: '这个瓜我蹲了一整天了，终于有人整理出来了！51吃瓜网今日吃瓜的速度真的没话说，全网最新吃瓜还得看这里。',
    likes: 892,
  },
  {
    user: '匿名围观者',
    avatar: '匿',
    time: '15分钟前',
    content: '我只能说这届网友太强了，什么都扒得出来。看了这个吃瓜资源合集才发现自己错过了好多细节，每日吃瓜精选太香了！',
    likes: 567,
  },
  {
    user: '深夜吃瓜人',
    avatar: '夜',
    time: '32分钟前',
    content: '凌晨三点还在刷51吃瓜官网的不会只有我吧？这个站更新实在是太快了，根本停不下来，每条都想看。',
    likes: 423,
  },
  {
    user: '理性吃瓜君',
    avatar: '理',
    time: '1小时前',
    content: '作为老51吃瓜群众了，说句公道话：这个站的爆料虽然快，但大部分都有据可查，比那些纯造谣的靠谱多了。已经推荐给身边所有人了。',
    likes: 315,
  },
  {
    user: '瓜田守护者',
    avatar: '守',
    time: '2小时前',
    content: '吃瓜多年，51吃瓜网今日吃瓜真的是体验最好的平台没有之一！界面干净、更新快、投稿群也活跃，吃瓜人的快乐老家。',
    likes: 268,
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-2">
          <i className="ri-chat-smile-2-line text-primary-500 mr-2 w-6 h-6 inline-flex items-center justify-center align-middle"></i>
          瓜友热评
        </h2>
        <p className="text-sm text-foreground-500 mb-8">看看51吃瓜群众都在聊什么</p>

        <div className="space-y-4">
          {comments.map((item, i) => (
            <div
              key={i}
              className="bg-background-50 border border-background-200/60 rounded-lg p-4 md:p-5"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-9 h-9 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                  <span className="text-xs font-bold text-primary-600">{item.avatar}</span>
                </div>
                <div>
                  <p className="text-sm font-medium text-foreground-800">{item.user}</p>
                  <p className="text-xs text-foreground-400">{item.time}</p>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-3">{item.content}</p>
              <div className="flex items-center gap-4">
                <span className="text-xs text-foreground-400 flex items-center gap-1 cursor-pointer hover:text-primary-500 transition-colors">
                  <i className="ri-heart-line w-3 h-3 flex items-center justify-center"></i>
                  {item.likes}
                </span>
                <span className="text-xs text-foreground-400 flex items-center gap-1 cursor-pointer hover:text-primary-500 transition-colors">
                  <i className="ri-chat-1-line w-3 h-3 flex items-center justify-center"></i>
                  回复
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}